import { queryOptions } from '@tanstack/react-query';

import { serviceCatalogApi } from './service-catalog.api';

export const queryKeys = {
    all: ['service-catalog'] as const,
};

export function serviceCatalogOptions() {
    return queryOptions({
        queryKey: queryKeys.all,
        queryFn: ({ signal }) => serviceCatalogApi.get(signal),
    });
}
